import React, { Component } from 'react';
import Snackbar             from 'material-ui/Snackbar';

class Message extends Component {

    closeMessage = () => {
        this.props.close();
    };

    render = () => {
        return (
            <Snackbar
                open={ this.props.message.open }
                message={ this.props.message.message }
                autoHideDuration={ this.props.message.timeout }
                onRequestClose={this.closeMessage}
            />
        );
    }

}

export default Message;


// WEBPACK FOOTER //
// ./src/components/Message.js